import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { EndPointApi } from '@helpers/endpointapi';
import { Common } from 'icreate/common/models/common';
import { OpsUser } from 'icreate/common/models/ops-user';
import { lastValueFrom } from 'rxjs';
import { RuntimeEnvironments } from '../models/runtime-enviroment.enum';
import { EnvironmentService } from './environment.service';

@Injectable({
    providedIn: 'root',
})
export class CommonService {
    private domain: string;
    private headers: any = new HttpHeaders({
        'Content-Type': 'application/json',
    });
    private env: RuntimeEnvironments;

    constructor(
        private http: HttpClient,
        private environmentService: EnvironmentService
    ) {
        this.domain = EndPointApi.iApiDomain();
        this.env = this.environmentService.getEnvironment();
    }

    async getOne(vesselId: string) {
        return await lastValueFrom(
            this.http.get<Common>(`${this.domain}/api/common`, {
                headers: this.headers,
                params: { vesselId },
            })
        );
    }

    async create(commonData: Common) {
        return await lastValueFrom(
            this.http.post<Common>(`${this.domain}/api/common`, commonData, {
                headers: this.headers,
            })
        );
    }

    async update(commonData: Common) {
        return await lastValueFrom(
            this.http.put(`${this.domain}/api/common/${commonData.id}`, commonData, {
                headers: this.headers,
            })
        );
    }

    async deleteComm(commonId: string) {
        return await lastValueFrom(this.http.delete(`${this.domain}/api/common/${commonId}`));
    }

    async isJrcsEmployee(email: string) {
        if (this.env == RuntimeEnvironments.ELECTRON) return false;
        return await lastValueFrom(
            this.http.get<boolean>(`${this.domain}/api/common/check-employee`, {
                params: { email },
            })
        );
    }
}
